<template>
  <div class="cf-card cf-flex cf-flex--row cf-flex--justify-space-between cf-flex--gap-16 cf-mobile-column">
    <!-- Left Side of Row -->
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--gap-16">
      <!-- Fulfillement type icon -->
      <img
        v-if="fulfillmentType.imageUrl"
        :src="fulfillmentType.imageUrl"
        :alt="fulfillmentType.name"
        class="cf-order-mode-image"
      >
      <span
        v-else
        :class="`cf-icon primary far ${ fulfillmentType.icon }`"
      />

      <div class="cf-flex cf-flex--column cf-flex--gap-10">
        <div class="cf-flex cf-flex--row cf-flex--gap-10">
          <!-- Fulfillement Type -->
          <h4 class="cf-title cf-title--4">
            {{ fulfillmentType.name }}
          </h4>

          <!-- Order Date -->
          <p class="cf-subtitle cf-subtitle--2">
            {{ $momentCalendar(orderHistoryItem.orderDate, null, orderHistoryItem.store.timeZone) }}
          </p>
        </div>

        <div class="cf-flex cf-flex--row cf-flex--gap-10">
          <!-- Number of Items -->
          <p
            v-if="orderHistoryItem.orderItemCount > 0"
            class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy"
          >
            {{ orderHistoryItem.orderItemCount }} Item<template v-if="orderHistoryItem.orderItemCount > 1">s</template>
          </p>

          <!-- Order Total -->
          <p class="cf-subtitle cf-subtitle--3 cf-subtitle--heavy">
            {{ $dollars(orderHistoryItem.total) }}
          </p>

          <!-- Ticket Number -->
          <p class="cf-subtitle cf-subtitle--3 cf-text-italics">
            #{{ orderHistoryItem.ticketNumber }}
          </p>
        </div>
      </div>
    </div>

    <!-- Right Side of Row -->
    <div class="cf-flex cf-flex--row cf-flex--align-center cf-flex--justify-end cf-flex--gap-10 cf-mobile-column buttons-container">
      <button
        class="cf-button cf-button--secondary cf-button--md cf-button--fill"
        type="button"
        @click="viewReceiptClickHandler"
      >
        View Receipt
      </button>

      <button
        v-if="showOrderAgainButton"
        class="cf-button cf-button--primary cf-button--md cf-button--fill"
        :class="{
          'cf-button--loading': reorderingOrderId === orderHistoryItem.orderId
        }"
        type="button"
        @click="reorderClickHandler"
      >
        Reorder
      </button>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import errorHandlers from '@/services/error-handlers';


  export default {
    name: 'OrderHistoryItem',

    props: {
      orderHistoryItem: {
        type: Object,
        required: true
      }
    },

    data() {
      return {
        reorderingOrderId: null
      };
    },


    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('session', ['orderDetails']),

      fulfillmentType() {
        const { fulfillmentType, menuType } = this.orderHistoryItem;
        const { metadata } = this.content.OrderModes;

        switch (true) {
          case fulfillmentType === 'DineIn':
            return { name: metadata.menuTypeLabelDineIn, icon: 'fa-utensils', imageUrl: metadata.dineInImageUrl };

          case (fulfillmentType === 'Takeout' && menuType === 'Catering'):
            return { name: metadata.cateringPickupLabel, icon: 'fa-hat-chef', imageUrl: metadata.cateringPickupImageUrl };

          case (fulfillmentType === 'Delivery' && menuType === 'Catering'):
            return { name: metadata.cateringDeliveryLabel, icon: 'fa-car', imageUrl: metadata.cateringDeliveryImageUrl };

          case fulfillmentType === 'Delivery':
            return { name: metadata.menuTypeLabelDelivery, icon: 'fa-car', imageUrl: metadata.deliveryImageUrl };

          case fulfillmentType === 'Shipping':
            return { name: metadata.menuTypeLabelShipping, icon: 'fa-truck', imageUrl: metadata.shippingImageUrl };

          case fulfillmentType === 'RoomService':
            return { name: metadata.menuTypeLabelRoomService, icon: 'fa-door-closed', imageUrl: metadata.roomServiceImageUrl };

          case fulfillmentType === 'External':
            return { name: 'Text to Pay', icon: 'fa-comments-alt-dollar' };

          case fulfillmentType === 'Curbside':
            return { name: metadata.menuTypeLabelCurbsidePickup || 'Curbside Pickup', icon: 'fa-car-side', imageUrl: metadata.curbsidePickupImageUrl };

          case fulfillmentType === 'DriveThrough':
            return { name: metadata.menuTypeLabelDriveThruPickup || 'Drive Thru Pickup', icon: 'fa-car', imageUrl: metadata.driveThruPickupImageUrl };

          default:
            return { name: metadata.menuTypeLabelPickup, icon: 'fa-shopping-bag', imageUrl: metadata.pickupImageUrl };
        }
      },

      showOrderAgainButton() {
        return this.orderDetails.orderType !== 'catering'
          && this.selectedLocation.isReadyForOrdering
          && !this.menu.unavailablePerSchedule
          && this.orderHistoryItem.fulfillmentType !== 'External';
      }
    },

    methods: {
      async reorderClickHandler() {
        try {
          this.reorderingOrderId = this.orderHistoryItem.orderId;

          await this.$store.dispatch('orders/reorder', this.orderHistoryItem);

          // this.$triggerGoogleTrackingEvent('AddOrderHistoryToCart', 'Menu');

          this.$triggerNewRelicEvent('AddOrderHistoryToCart', 'Information', 'Added Order History To Cart');

          this.$closeModal('orderHistoryReceipt');

          this.$router.push({
            name: 'orderMenu',
            params: {
              merchantId: this.$route.params.merchantId
            }
          });
        }

        catch (error) {
          errorHandlers.generic(error);
        }

        finally {
          this.reorderingOrderId = null;
        }
      },

      viewReceiptClickHandler() {
        const modalPayload = { order: this.orderHistoryItem };

        this.$openModal('orderHistoryReceipt', modalPayload);
      }
    }
  };
</script>

<style lang="sass">
  .buttons-container
    max-width: 450px

    button
      width: 200px
</style>
